export default __webpack_public_path__ + "static/media/JS.490903f8.png";